import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MaterialModule } from '../../_shared';
import { ToastrService } from '../../_services';

import { RouterLink } from "@angular/router";

@Component({
  selector: 'story-home',
  templateUrl: './home.html',
  styleUrl: './home.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MaterialModule, RouterLink],
})
export class Home implements OnInit {

  
  constructor(
    private toastr: ToastrService
  ) {}


  ngOnInit(): void {

  }


}